import React, { useState, useEffect } from "react";
//import { Route } from "react-router-dom";
//import PropTypes from "prop-types";
import Spinner from "../common/Spinner";
import TextFieldGroup from "../common/TextFieldGroup";
import ProfileItem from "./ProfileItem";
import { useSelector, useDispatch } from "react-redux";
import { getProfiles } from "../../actions/profileActions";
import { profilesTitle } from "../../settings/mains/Dashboard.utils";
//import SearchBox from "../common/SearchBox";

const Profiles = ({ match }) => {
  const profile = useSelector((state) => state.profile);
  const [Search, setSearch] = useState({
    search: "",
  });

  const { search } = Search;
  const { profiles, loading } = profile;

  // let filteredProfiles =
  //   profiles &&
  //   profiles.filter(
  //     (profile) =>
  //       profile.user.name.toLowerCase().indexOf(search.toLowerCase()) !== -1
  //   );

  let filteredProfiles =
    profiles &&
    profiles.filter((profile) =>
      Object.values(profile)
        .join("")
        .toLowerCase()
        .includes(search.toLowerCase())
    );

  const updateSearch = (event) =>
    setSearch({ ...Search, search: event.target.value.substr(0, 30) });

  let profileItems;

  if (profiles === null || loading) {
    profileItems = <Spinner />;
  } else {
    if (profiles.length > 0) {
      profileItems = filteredProfiles
        .reverse()
        .map((profile) => <ProfileItem key={profile._id} profile={profile} />);
    } else {
      profileItems = <h4>No profiles found...</h4>;
    }
  }
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getProfiles());
  }, [dispatch]);

  return (
    <div className="profiles">
      <div className="container">
        <div className="row ">
          <div className="col-md-12">
            <h1 className="display-4 text-center">{profilesTitle}</h1>
            <p className="lead text-center">
              Browse,assign a mission and connect with {profileItems.length}{" "}
              Tenants
            </p>

            <div>
              <TextFieldGroup
                placeholder="Search"
                name="search"
                style={{ width: "50%" }}
                value={search}
                onChange={updateSearch}
                info="Filter by || name || status|| maxbudget || city || country || bio || date"
              />
            </div>
            <div>{profileItems}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Profiles.propTypes = {
//   getProfiles: PropTypes.func.isRequired,
//   profile: PropTypes.object.isRequired,
// };

export default Profiles;
